<script setup>
import { NaverMap, NaverMarker } from 'vue3-naver-maps';

const mapOptions = {
  latitude: 37.4798201658914, // 지도 중앙 위도
  longitude: 126.95333696362, // 지도 중앙 경도
  zoom: 17,
};

</script>

<template>
    <naver-map
    style="width: 100%; height: 100%"
    :map-options="mapOptions"
  >
    <naver-marker
      latitude="37.4798201658914"
      longitude="126.95333696362"
    />
  </naver-map>
</template>

<style scoped>
.error-message {
  color: red;
  margin-top: 10px;
  font-weight: bold;
}
</style>
